import styled from 'styled-components';

import {colors} from '@app/styles/theme';

export const MetricCardGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;
    padding: 20px;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
    background: ${colors.white};
`;

export const Card = styled.div<{$hasIcon: boolean}>`
    display: ${({$hasIcon}) => ($hasIcon ? 'grid' : 'flex')};
    flex-direction: column;
    grid-template-columns: auto 1fr;
    grid-template-rows: auto auto;
    grid-column-gap: 10px;
    grid-row-gap: 6px;
    padding: 16px;
    border-radius: 8px;
    border: 1px solid ${colors.textMuted};
`;

export const IconBox = styled.div<{color?: string}>`
    grid-row: 1 / -1;
    align-self: center;
    display: grid;
    place-content: center;
    padding: 12px;
    border-radius: 4px;
    background: ${({color}) => color ?? colors.brandPrimary};
    color: ${colors.white};
    font-size: 22px;
    font-weight: 600;
    line-height: 1;
`;

export const Label = styled.h3`
    margin: 0;
    font-size: 18px;
    font-weight: 400;
    line-height: 1.3;
`;

export const Value = styled.div`
    font-size: 20px;
    font-weight: 600;
    line-height: 1.3;
`;
